<template>
  <component :is="dataView"></component>
</template>

<script>
/* eslint-disable */

const NoPermission = () => import('./403')
import contentPage from './403'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      route: "",
      error: null,
    }
  },
  computed: {
    dataView() {//temporary deactivating checking permission
      return (this.permission && this.permission[this.route] && this.permission[this.route].all) ? 'contentPage' : 'contentPage' //NoPermission
    },
    ...mapGetters([
      'permission',
    ])
  },
  components: {
    'contentPage' : contentPage
  }
}
</script>
